import { render, staticRenderFns } from "./FIBCookieConsentModal.vue?vue&type=template&id=4209ffc0&scoped=true&"
import script from "./FIBCookieConsentModal.vue?vue&type=script&lang=js&"
export * from "./FIBCookieConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./FIBCookieConsentModal.vue?vue&type=style&index=0&id=4209ffc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4209ffc0",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
